"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var theme_1 = __importDefault(require("../../../styles/theme"));
var objectUtilities_1 = require("../../../util/objectUtilities");
var Typography_1 = require("../Typography/Typography");
var StatusLabel_style_1 = __importDefault(require("./StatusLabel.style"));
/**
 * StatusLabel atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-statuslabels-statuslabel--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/StatusLabel Source}
 */
var StatusLabel = function (_a) {
    var status = _a.status, statusColor = _a.statusColor, amendment = _a.amendment, _b = _a.direction, direction = _b === void 0 ? 'row' : _b, className = _a.className, overflowEllipsis = _a.overflowEllipsis, other = __rest(_a, ["status", "statusColor", "amendment", "direction", "className", "overflowEllipsis"]);
    var classes = (0, StatusLabel_style_1.default)({ direction: direction });
    function getVariantStyle() {
        switch (statusColor) {
            case 'gray':
                return classes.gray;
            case 'green':
                return classes.green;
            case 'red':
                return classes.red;
            case 'blue':
                return classes.blue;
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(statusColor);
        }
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, amendment && classes.statusWrapper, className) }, other, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'headline3', overflowEllipsis: overflowEllipsis, className: (0, classnames_1.default)(classes.status, getVariantStyle()), noWrap: true }, { children: (0, lodash_1.capitalize)(status) })), amendment && ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'label1', color: theme_1.default.textColors.primaryLight, textAlign: 'center' }, { children: amendment })))] })));
};
exports.StatusLabel = StatusLabel;
